<template>
    <div :class="className" :style="{ height: eHeight, width: width }" />
  </template>
  <script>
  import * as echarts from "echarts";
  require("echarts/theme/macarons"); // echarts theme
  import resize from "./mixins/resize";
  
  export default {
    mixins: [resize],
    props: {
      className: {
        type: String,
        default: "chart",
      },
      width: {
        type: String,
        default: "100%",
      },
      eHeight: {
        type: String,
        default: "100%",
      },
      autoResize: {
        type: Boolean,
        default: true,
      },
      chartData: {
        type: Object,
        required: true,
      },
      proportion: {
      type: String,
      },
      title: {
        type: String,
      },
    },
    data() {
      return {
        chart: null,
        circleTitle: "",
      };
    },
    watch: {
      chartData: {
      deep: true,
      handler(val) {
        // console.log("触发",val)
        this.setOptions(val);
      },
    },
      title: {
        deep: true,
        handler(val) {
          this.circleTitle = this.title;
          // console.log(this.circleTitle);
        },
      },
    },
    mounted() {
      this.circleTitle = this.title;
      this.$nextTick(() => {
        this.initChart();
      });
    },
    beforeDestroy() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, "macarons");
        // this.setOptions(this.chartData || {});
      },
      setOptions(data) {
        // console.log("呼叫类型占比", data);
        if(data==undefined){
          return;
        }
        let _this = this;
        this.chart.setOption({
          title: {
            text: this.circleTitle,
            bottom: 0,
            left: "center",
            textStyle: {
              color: _this.isbig ? "#4AE8C8" : "#999",
            },
          },
          tooltip: {
            backgroundColor: 'rgba(255,255,255,1)'
          },
          series: [
            {
              type: "gauge",
              startAngle: 90,
              endAngle: -270,
              color: "#999",
              progress: {
                show: true,
                overlap: false,
                roundCap: true,
                clip: false,
                itemStyle: {
                  color: _this.isbig ? "#3A56B2" : "#1a90ff",
                },
              },
              pointer: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: [[1, "#e9e9e9"]],
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              data: [
                {
                  value: _this.proportion,
                  detail: {
                    offsetCenter: [0, 0],
                  },
                },
              ],
              detail: {
                fontSize: 14,
                color: _this.isbig ? "#4AE8C8" : "#333",
                formatter: "{value}%\n" + data,
              },
            },
          ],
        });
      },
    },
  };
  </script>
  